import type { RootState } from '@oneview/redux/rootReducer';
import { UmaUser } from '@oneview/types';
import { createSelector } from '@reduxjs/toolkit';

export const selectAuth = (state: RootState) => state.auth;

export const selectCurrentUser = createSelector(selectAuth, (auth) => auth.user);

export const selectCurrentAccountId = createSelector(selectAuth, (auth) => auth.currentClientAccount?.accountId || 0);

export const selectCurrentAccount = createSelector(selectAuth, (auth) => auth.currentClientAccount);

export const selectUmaUser = createSelector(selectAuth, (auth) => auth.umaUser as unknown as UmaUser | null);

export const selectMfaLoginStage = createSelector(selectAuth, (auth) => auth.mfaLoginStage);

export const selectAvailableMfaOptions = createSelector(selectAuth, (auth) => auth.availableMfaOptions);
